export const LogsTypeTraductionKey = {
    // WmsItem
    'wmsitem_creation': "wms.logType.wmsItem.creation",
    'wmsitem_in_mission': "wms.logType.wmsItem.in_mission",
    'wmsitem_in_picking': "wms.logType.wmsItem.in_picking",
    'wmsitem_removed_from_task': "wms.logType.wmsItem.removed_from_task",
    'wmsitem_task_stopped': "wms.logType.wmsItem.task_stopped",
    'wmsitem_picked': "wms.logType.wmsItem.picked",
    'wmsitem_sorted': "wms.logType.wmsItem.sorted",
    'wmsitem_ready_to_be_packed': "wms.logType.wmsItem.ready_to_be_packed",
    'wmsitem_reset_packing': "wms.logType.wmsItem.reset_packing",
    'wmsitem_packing': "wms.logType.wmsItem.packing",
    'wmsitem_packed': "wms.logType.wmsItem.packed",
    'wmsitem_ready_to_be_shipped': "wms.logType.wmsItem.ready_to_be_shipped",
    'wmsitem_shipped': "wms.logType.wmsItem.shipped",
    'wmsitem_cc_ready': "wms.logType.wmsItem.cc_ready",
    'wmsitem_cc_collected': "wms.logType.wmsItem.cc_collected",
    'wmsitem_cc_cancelled': "wms.logType.wmsItem.cc_cancelled",
    'wmsitem_cancelled': "wms.logType.wmsItem.cancelled",
    'wmsitem_waiting_to_be_cancelled': "wms.logType.wmsItem.waiting_to_be_cancelled",
    'wmsitem_not_found': "wms.logType.wmsItem.not_found",
    'wmsitem_container_changed': "wms.logType.wmsItem.container_changed",
    'wmsitems_mass_transferred': "wms.logType.wmsItem._mass_transferred",
    'wmsitem_inventory_changed': "wms.logType.wmsItem.inventory_changed",

    // LineItem
    'lineitem_wms_ready': "wms.logType.lineItem.wms_ready",
    'lineitem_wms_split_shipment_changed': "wms.logType.lineItem.wms_split_shipment_changed",
    'lineitem_wms_to_ship': "wms.logType.lineItem.wms_to_ship",
    'lineitem_wms_shipped': "wms.logType.lineItem.wms_shipped",
    'lineitem_wms_in_return_retailer': "wms.logType.lineItem.wms_in_return_retailer",
    'lineitem_wms_in_return_runner': "wms.logType.lineItem.wms_in_return_runner",
    'lineitem_wms_returned': "wms.logType.lineItem.wms_returned",
    'lineitem_wms_return_cancelled': "wms.logType.lineItem.wms_return_cancelled",
    'lineitem_wms_cancelled': "wms.logType.lineItem.wms_cancelled",
    'lineitem_wms_unavailable': "wms.logType.lineItem.wms_unavailable",
    'lineitem_wms_cc_inventory_change': "wms.logType.lineItem.wms_cc_inventory_change",

    // Shipment
    'shipment_wms_in_wms': "wms.logType.shipment.wms_in_wms",
    'shipment_wms_prepare': "wms.logType.shipment.wms_prepare",
    'shipment_wms_split_creation': "wms.logType.shipment.wms_split_creation",
    'shipment_wms_split_split': "wms.logType.shipment.wms_split_split",
    'shipment_wms_cc_transit': "wms.logType.shipment.wms_cc_transit",
    'shipment_wms_cc_reception': "wms.logType.shipment.wms_cc_reception",
    'shipment_wms_shipment_shipped': "wms.logType.shipment.wms_shipment_shipped",
    'shipment_wms_container_changed': "wms.logType.shipment.wms_container_changed",

    // WmsTask
    'task_creation': "wms.logType.task.creation",
    'task_in_progress': "wms.logType.task.in_progress",
    'task_completed': "wms.logType.task.completed",
    'task_cancelled': "wms.logType.task.cancelled",

    // Container
    'container_disabled': "wms.logType.container.disabled",
    'container_enabled': "wms.logType.container.enabled",
    'container_member': "", // Can't track, API makes the corresponding events.
    'container_shipping_method_changed': "", // Can't track, the corresponding event doesn't exist YET.
    'container_computerid': "", // Can't track, the corresponding event doesn't exist YET.
    'container_max_capacity': "", // Can't track, API makes the corresponding events.

    // General
    'persist': 'wms.logType.persist',
    'update': 'wms.logType.update',
    'remove': 'wms.logType.remove'
}